parseObjectTypeExtension